export default class SuccessReportModel {

    constructor(public id: string, public courseID: string, public title: string,
        public description: string, public duration: string, public languages: string[], public date: number) {
    }
}